export interface UserFacingValidationError {
  title: string;
  message: string;
}

export function mapValidationErrors(errors: string[]): UserFacingValidationError[] {
  return errors.map(error => {
    if (
      error.includes('not valid JSON')
      || error.includes('State format is heavily corrupted')
      || error.includes('does not match schema version')
      || error.includes('missing a numeric schemaVersion')
    ) {
      return {
        title: 'Invalid import file',
        message: 'The supplied content is not a valid application state JSON document.'
      };
    }

    if (error.includes('schema version')) {
      return {
        title: 'Unsupported data version',
        message: 'This JSON snapshot was created with a schema version the current app cannot read safely.'
      };
    }

    if (error.includes('Duplicate category ID')) {
      return {
        title: 'Category data conflict',
        message: 'The imported file contains duplicate category identifiers.'
      };
    }

    if (error.includes('Duplicate card ID')) {
      return {
        title: 'Card data conflict',
        message: 'The imported file contains duplicate card identifiers.'
      };
    }

    if (
      error.includes('Category ID must')
      || error.includes('Category name cannot be empty')
      || error.includes('Category color is invalid')
      || error.includes('Category system flag is invalid')
    ) {
      return {
        title: 'Category problem',
        message: 'One or more categories in the imported data are malformed or incomplete.'
      };
    }

    if (
      error.includes('Card belongs to an invalid category')
      || error.includes('Card category reference is invalid')
    ) {
      return {
        title: 'Broken category reference',
        message: 'One or more cards reference a missing or invalid category.'
      };
    }

    if (
      error.includes('Saved timestamp')
      || error.includes('Card creation date')
      || error.includes('Card update date')
      || error.toLowerCase().includes('deadline')
    ) {
      return {
        title: 'Date problem',
        message: 'One or more saved dates or timestamps are invalid or inconsistent.'
      };
    }

    if (error.includes('UI ladder filter') || error.includes('UI all cards filter')) {
      return {
        title: 'Filter settings problem',
        message: 'The saved filter configuration is invalid and cannot be applied safely.'
      };
    }

    if (
      error.includes('Ladder levels')
      || error.includes('Lane uniqueness broken')
      || error.includes('Priority and importance')
      || error.includes('Card importance must')
      || error.includes('Card priority must')
    ) {
      return {
        title: 'Ladder ordering problem',
        message: 'The saved ladder positions are inconsistent or refer to invalid levels.'
      };
    }

    if (error.includes('Hierarchy violation')) {
      return {
        title: 'Hierarchy problem',
        message: 'One or more parent-child relationships in the imported data violate the one-level hierarchy rules.'
      };
    }

    if (error.includes('references itself as parent')) {
      return {
        title: 'Invalid parent reference',
        message: 'One or more items in the imported data reference themselves as their own parent, which is not allowed.'
      };
    }

    if (error.includes('references a missing parent')) {
      return {
        title: 'Missing parent reference',
        message: 'One or more items in the imported data reference a parent that does not exist.'
      };
    }
    if (error.toLowerCase().includes('deadline')) {
      return {
        title: 'Deadline problem',
        message: 'One or more imported deadlines are invalid or earlier than the card creation date.'
      };
    }

    if (error.includes('Uncategorized')) {
      return {
        title: 'Required category missing',
        message: 'The protected Uncategorized category is missing or invalid in the imported data.'
      };
    }

    return {
      title: 'Validation issue',
      message: error
    };
  });
}

export function mapValidationErrorsToStrings(errors: string[]): string[] {
  return mapValidationErrors(errors).map(entry => `${entry.title}: ${entry.message}`);
}